const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getMyAccountApi = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[getMyAccountApi] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.'); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/my-account`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();

      console.error('[getMyAccountApi] Ошибка получения данных аккаунта администратора:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    console.log(data)
    return data;
  } catch (error) {
    console.error('[getMyAccountApi] Ошибка сети или другая ошибка при получении данных аккаунта администратора:', error);
    throw error;
  }
};